import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Input, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const TextQuoteModal = ({
  openTextQuoteModal,
  setOpenTextQuoteModal,
  sendContract,
  contract
}) => {
  const { t } = useTranslation();
  const [object, setObject] = useState('Votre devis');
  const [hello, setHello] = useState(
    `Bonjour ${contract?.customer?.first_name} ${contract?.customer?.last_name},`
  );
  const [content, setContent] = useState(
    `Vous trouverez ci-joint, votre devis N°${contract?.number}.`
  );
  const [conclusion, setConclusion] = useState(
    `${contract?.insurer?.name} reste à votre disposition pour toutes autres demandes.`
  );
  const [cordially, setCordially] = useState('Bien cordialement,');
  const [signature, setSignature] = useState('Votre courtier');

  return (
    <>
      <Modal
        title={t(`contracts.modal_quote.content_title`)}
        centered
        style={{ top: 20 }}
        open={openTextQuoteModal}
        onCancel={() => {
          setOpenTextQuoteModal(false);
        }}
        width={750}
        footer={[
          <div style={{ textAlign: 'center', fontWeight: 700 }}>
            <Button
              onClick={() => {
                sendContract({
                  object,
                  hello,
                  content,
                  conclusion,
                  cordially,
                  signature
                });
                setOpenTextQuoteModal(false);
              }}
              type="primary"
              style={{
                width: 'auto',
                padding: '4px 15px'
              }}
            >
              {t('buttons.send')}
            </Button>
          </div>
        ]}
      >
        <Text>{t(`contracts.modal_quote.object`)}</Text>
        <Input.TextArea
          allowClear
          maxLengt={800}
          autoSize
          defaultValue={object}
          onChange={(e) => setObject(e.target.value)}
          style={{ marginBottom: '2em' }}
        />
        <Text>{t(`contracts.modal_quote.content`)}</Text>
        <Input.TextArea
          allowClear
          maxLengt={800}
          autoSize
          defaultValue={hello}
          onChange={(e) => setHello(e.target.value)}
          style={{ marginBottom: '1em' }}
        />
        <Input.TextArea
          allowClear
          maxLengt={800}
          autoSize
          defaultValue={content}
          onChange={(e) => setContent(e.target.value)}
        />
        <div style={{ textAlign: 'center' }}>
          <Button
            type="primary"
            shape="round"
            disabled
            style={{
              marginTop: '2em',
              marginBottom: '2em'
            }}
          >
            {t(`contracts.modal_quote.client_access`)}
          </Button>
        </div>
        <Input.TextArea
          allowClear
          maxLengt={800}
          autoSize
          defaultValue={conclusion}
          onChange={(e) => setConclusion(e.target.value)}
          style={{ marginBottom: '1em' }}
        />
        <Input.TextArea
          allowClear
          maxLengt={800}
          autoSize
          defaultValue={cordially}
          onChange={(e) => setCordially(e.target.value)}
          style={{ marginBottom: '1em' }}
        />
        <Input.TextArea
          allowClear
          maxLengt={800}
          autoSize
          defaultValue={signature}
          onChange={(e) => setSignature(e.target.value)}
          style={{ marginBottom: '1em' }}
        />
      </Modal>
    </>
  );
};

TextQuoteModal.propTypes = {
  openTextQuoteModal: PropTypes.bool.isRequired,
  setOpenTextQuoteModal: PropTypes.func.isRequired,
  sendContract: PropTypes.func.isRequired,
  contract: PropTypes.shape({
    number: PropTypes.string,
    customer: PropTypes.shape({
      gender: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string
    }),
    insurer: PropTypes.shape({
      name: PropTypes.string
    })
  }).isRequired,
  form: PropTypes.shape({
    resetFields: PropTypes.func
  }).isRequired
};

export default TextQuoteModal;
